<template>
  <div class="space-y-2">
    <slot />
  </div>
</template>
